import React, { useCallback } from 'react';
import { mergeStyles } from '@cian/utils';

import { Card } from '../Card';
import { Text } from '../Text';
import { Button } from '../Button';
import { trackCardClick } from '../tracking/trackCardClick';

import { EPageKind } from '../../../types/page';
import { ICard } from '../SimplifiedCards/cards';
import styles from './SimplifiedCard.css';

interface IProps extends ICard {
  pageKind: EPageKind;
  className?: string;
}

export const SimplifiedCard = ({ pageKind, title, imageUrl, description, link, className }: IProps) => {
  const { className: rootClassName } = mergeStyles(styles['card'], className);
  const trackClick = useCallback(() => trackCardClick({ pageKind, cardTitle: title }), []);

  return (
    <Card className={rootClassName} link={link} onClick={trackClick}>
      <img src={imageUrl} className={styles['icon']} />

      <div className={styles['content']}>
        <Text type="h4" lineClamp={2} className={styles['title']}>
          {title}
        </Text>
        <Text lineClamp={4} className={styles['description']}>
          {description}
        </Text>
      </div>

      <Button className={styles['button']}>Узнать больше</Button>
    </Card>
  );
};
